module.exports = __webpack_public_path__ + "images/emoji/stars.fe50548f98f7fb911179.png";


//////////////////
// WEBPACK FOOTER
// ./resources/images/emoji/stars.png
// module id = Dvsg
// module chunks = 13